import React from 'react';

// This causes webpack to include all images in this folder
// as when it builds the tree it can't know the value of src
// Is a seperate function to allow rewire in test.
// eslint-disable-next-line import/no-dynamic-require
const include = src => require(`../../../client/images/${src}`);

export default function Image({ src, external, ...props }) {
  const imgSrc = external
    ? src
    : `/research-papers/assets/images/${src}`;

  if (process.browser && !external) include(src);

  return src
    ? <img src={imgSrc} alt="" {...props} />
    : null;
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Image.js